import React from 'react';
import autobind from "autobind-decorator";
import moment from "moment-jalaali";
import { connect } from 'react-redux';

import services from 'core/services';

import { PureComponent, Serialize, Loading, Page, GroupBox } from 'core/components';
import { Info } from 'content/components';
import { Row, Col, Icon, Link, List, ListItem, Button, Popup, CardContent, Segmented } from 'core/components/Framework7';

import classes from './styles.module.css';

const Price = Serialize.Price;

class OrdersProduct extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sheetOpened: false,
      popupOpened: false,
      loading: false,
      items: [],
    }
  }

  get envData() {
    const { env } = this.props;

    return {
      //info
      email: env ? env.info ? env.info.email ? env.info.email : null : null : null,
      phone: env ? env.info ? env.info.phone ? env.info.phone : null : null : null,
      aboutUs: env ? env.info ? env.info.aboutUs ? env.info.aboutUs : null : null : null,
      privacyPolicy: env ? env.info ? env.info.privacyPolicy ? env.info.privacyPolicy : null : null : null,
      customerClubUrl: env ? env.info ? env.info.customerClubUrl ? env.info.customerClubUrl : null : null : null,

      //socialNetworks
      instagramActive: env ? env.socialNetworks ? env.socialNetworks.instagram ? env.socialNetworks.instagram.active ? env.socialNetworks.instagram.active : null : null : null : null,
      instagramUrl: env ? env.socialNetworks ? env.socialNetworks.instagram ? env.socialNetworks.instagram.url ? env.socialNetworks.instagram.url : null : null : null : null,
      telegramActive: env ? env.socialNetworks ? env.socialNetworks.telegram ? env.socialNetworks.telegram.active ? env.socialNetworks.telegram.active : null : null : null : null,
      telegramUrl: env ? env.socialNetworks ? env.socialNetworks.telegram ? env.socialNetworks.telegram.url ? env.socialNetworks.telegram.url : null : null : null : null,
    }
  }

  static get defaultProps() {
    return {
      items: [],
    }
  }

  get initialValue() {
    let { items } = this.props
    if (this.state.items.length > 0) {
      items = this.state.items
    }

    // const { items } = this.props

    return items.map(item => {
      return this.parseOrder(item)
    })
  }

  get status() {
    return {
      0: { name: "Canceled", title: "لغو شده", color: "var(--order-step-canceled)", key: 0 },
      20: { name: "Registered", title: "ثبت شده", color: "var(--order-step-registered)", key: 20 },
      30: { name: "Seen", title: "مشاهده شده", color: "var(--order-step-seen)", key: 30 },
      40: { name: "Modified", title: "اعمال تغییرات در سفارش", color: "var(--order-step-modified)", key: 40 },
      50: { name: "Accepted", title: "تأیید شده", color: "var(--order-step-accepted)", key: 50 },
      60: { name: "SentToStock", title: "تحویل انبار", color: "var(--order-step-sent-to-stock)", key: 60 },
      70: { name: "StockModified", title: "تغییر کالا در انبار", color: "var(--order-step-stock-modified)", key: 70 },
      80: { name: "StockAccepted", title: "تأیید انبار", color: "var(--order-step-stock-accepted)", key: 80 },
      90: { name: "CourierSelected", title: "تحویل به پیک", color: "var(--order-step-courier-selected)", key: 90 },
      100: { name: "Sent", title: "ارسال شده", color: "var(--order-step-sent)", key: 100 },
      130: { name: "Delivered", title: "تحویل شده", color: "var(--order-step-delivered)", key: 130 },
      140: { name: "Completed", title: "تحویل شده", color: "var(--order-step-completed)", key: 140 },
      500: {name: "NotFound", title: "در دست بررسی", color: "var(--f7-theme-color)", key: 500},
    }
  }

  parseOrder(order) {
    return {
      id: order.id,
      status: order.status,
      stepStatus: this.status[order.status == 20 ? 0 : (order.steps && order.steps.length > 0 && order.steps[0].status || 500)] || this.status[500],
      price: order.finalPrice,
      createdAt: order.createdAt,
      updatedAt: order.updatedAt,
      trackingCode: order.trackingCode,
      titleAddress: order ? order.shippingInfo ? order.shippingInfo.address ? order.shippingInfo.address.title : '' : '' : '',
    }
  }

  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  refreshButtonClicked() {
    this.loading(true)

    services.ecommerce.Order.getOrders()
      .then(r => {
        this.setState({
          items: r.data.orders
        })
      })
      .finally(r => {
        this.loading(false)
      })
  }

  renderOrderItems() {
    const items = this.initialValue;
    // console.log('order items:', items)

    if (items.length === 0) return this.renderEmpty()

    return (
      <GroupBox outline title={'فهرست سفارشات'}>
        <CardContent>
          <List mediaList>
            {items.map(item => {
              return this.renderOrderItem(item)
            })}
          </List>
        </CardContent>
      </GroupBox>
    )
  }

  renderEmpty() {
    return (
      <div className={classes.empty}>لیست سفارشات شما خالی است</div>
    )
  }

  renderOrderItem(item) {

    return (
      <ListItem
        key={item.id}
        link={`/order/${item.id}`}
      // title={`شماره پیگیری ${item.trackingCode}`}
      // after={item.status === 20 ? "لغو شده" : item.stepStatus.title}
      // subtitle={item.trackingCode}
      // subtitle={`ارسال به ${item.titleAddress}`}
      >
        {/* title row */}
        <div slot='title'>
          <Row className={classes.trackinCodeTitle}>
            {'شماره پیگیری'}
          </Row>
          <Row>
            <span className={classes.trackingCodeText}>
              {item.trackingCode}
            </span>
          </Row>
        </div>
        <span slot='after' style={{ color: item.stepStatus.color }}>
          {item.stepStatus.title}
        </span>
        {/* icon */}
        <Icon
          slot="media"
          icon="mdi-receipt"
          style={{ color: item.stepStatus.color }}
        />
        {/* content */}
        <Row className={classes.orderContentItem}>
          <Col width="50">
            {moment(item.updatedAt).format("HH:mm jYYYY/jMM/jDD")}
          </Col>
          <Col width="50" className={classes.priceBox}>
            <Price price={item.price} />
          </Col>
        </Row>
      </ListItem>
    )
  }

  render() {
    const { navigate } = this.props

    return (
      <div className={classes.container}>
        <Row className={`${classes.containerTitle} button-top-full-width`}>
          <Button large
            text={'جهت لغو سفارش خود، کلیک کنید.'}
            popupOpen=".info"
            style={{ flex: '1 0 auto' }}
          />
          <Button large
            icon="mdi-sync"
            onClick={this.refreshButtonClicked}
          />
        </Row>

        <div className={`${classes.pagePadding}`}>
          {this.state.loading ?
            <Loading height={195} />
            :
            this.renderOrderItems()
          }
        </div>

        <Popup
          closeByOutsideClick swipeToClose
          className="info"
          opened={this.state.popupOpened}
          onPopupClosed={() => this.setState({ popupOpened: false })}
        >
          <Page
            pageName="support-call"
            title={'تماس با پشتیبانی'}
            showBack={false}
            showClose={true}
            closePopup={true}
            navigate={navigate}
          >
            <Info />
          </Page>
        </Popup>
      </div>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {

  }
)(autobind(OrdersProduct));
